export default __webpack_public_path__ + "static/media/img.aa137c10.jpg";